// import React from 'react';
import React, { useEffect } from 'react';

function Navbar() {
    useEffect(() => {
        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        document.getElementById('date-time').innerHTML = date;
      }, 
      []); 
      // Empty dependency array ensures the code runs only once when the component mounts.
    

    return (
        <nav className="navbar">
        <div className="time-container">
            <span id="date-time"></span>
        </div>
        </nav>
    );
    }



export default Navbar;